module.exports = __webpack_public_path__ + "static/edit-file-to-show-products-by-category-in-empty-category-4e258bcf89b535a86ec55ae6b4b5d87e.png";